import { types } from 'mobx-state-tree';
import { OrderOptionsStore } from './OrderOptionsStore';

const OrderOptionsStoreManager = types
	.model('OrderOptionsStoreManager', {
	})
	.views(self => {
		const map = {};

		function get(templateId: number) {
			let r = map[templateId];
			if (r) return r;
			return map[templateId] = OrderOptionsStore.create({templateId: templateId+''});
		}

		return {
			get,
		};
	});

export const orderOptionsStoreManager = OrderOptionsStoreManager.create();
